import { Fragment, useMemo, useState } from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import { getAdministratorColumns } from "../../Components/admin/administrator.columns";
import { AdministratorModal } from "../../Components/admin/AdministratorModal";
import { PageHeader } from "../../Components/common/PageHeader";

export const AdministratorList = () => {
  const { getData } = useDataFetch();

  const { data, isLoading } = getData(["administrators"], "/administrators/all", { enabled: true });

  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    password: "",
    role: "ADMIN",
  });
  const [isPasswordEdit, setIsPasswordEdit] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
    setIsPasswordEdit(false);
    setFormData({ id: "", name: "", email: "", password: "", role: "ADMIN" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (admin) => {
    setIsPasswordEdit(false);
    setFormData({
      id: admin.id,
      name: admin.name,
      email: admin.email,
      password: "",
      role: admin.role,
    });
    setModalOpen(true);
  };

  const handleEditPassword = (admin) => {
    setIsPasswordEdit(true);
    setFormData({
      id: admin.id,
      name: admin.name,
      email: admin.email,
      password: "",
      role: admin.role,
    });
    setModalOpen(true);
  };

  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () =>
      getAdministratorColumns(
        columnHelper,
        handleEdit,
        handleEditPassword
      ),
    [columnHelper]
  );

  const admins = data?.data?.administrators ?? [];

  // `/administrators/all` no pagina en el backend: pagina en cliente sobre
  // lo ya cargado, sin duplicar el fetch.
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const pageData = admins.slice(
    pagination.pageIndex * pagination.pageSize,
    (pagination.pageIndex + 1) * pagination.pageSize
  );

  return (
    <Fragment>
      <PageHeader
        title="Administradores"
        crumbs={[{ label: "Administradores" }]}
        actions={
          <button
            type="button"
            className="btn btn-primary btn-sm d-flex align-items-center gap-1"
            onClick={() => {
              setIsPasswordEdit(false);
              setFormData({ id: "", name: "", email: "", password: "", role: "ADMIN" });
              setModalOpen(true);
            }}
          >
            <i className="ri-user-add-line" /> Registrar administrador
          </button>
        }
      />

      <DataTable
        data={pageData}
        total={admins.length}
        pagination={pagination}
        setPagination={setPagination}
        columns={columns}
        progressPending={isLoading}
        emptyMessage="No hay administradores para mostrar."
      />

      <AdministratorModal
        modalOpen={modalOpen}
        formData={formData}
        isPasswordEdit={isPasswordEdit}
        handleChange={handleChange}
        closeModal={closeModal}
      />
    </Fragment>
  );
};
